/* index.tsx generated by @compiled/babel-plugin v0.29.1 */
import _extends from "@babel/runtime/helpers/extends";
import "./index.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { forwardRef } from 'react';
import WarningIcon from '@atlaskit/icon/utility/warning';
import { Box, Pressable, xcss } from '@atlaskit/primitives';
import { SparkleIcon } from './SparkleIcon';
const buttonStyles = xcss({
  borderWidth: 'border.width',
  borderStyle: 'solid',
  backgroundColor: 'elevation.surface',
  borderRadius: 'border.radius.100',
  paddingInline: 'space.150',
  paddingBlock: 'space.075',
  minHeight: '32px',
  color: 'color.text',
  transitionProperty: 'color, background-color',
  transitionDuration: '200ms',
  display: 'flex',
  gap: 'space.100',
  alignItems: 'center',
  fontWeight: "var(--ds-font-weight-medium, 500)",
  ':hover': {
    backgroundColor: 'color.background.neutral.subtle.hovered'
  },
  ':active': {
    backgroundColor: 'color.background.neutral.subtle.pressed'
  }
});
const brandStyles = xcss({
  color: 'color.text.brand',
  borderColor: 'color.border.brand'
});
const warningStyles = xcss({
  borderColor: 'color.border.warning'
});
const dangerStyles = xcss({
  borderColor: 'color.border.danger'
});
const iconStyles = xcss({
  display: 'flex',
  // icon size cannot grow and shrink
  flexGrow: 0,
  flexShrink: 0,
  alignSelf: 'center',
  fontSize: 0,
  lineHeight: 0,
  userSelect: 'none'
});
const sparkleAnimation = null;
const sparkleStyles = null;
export const EditionAwarenessButton = /*#__PURE__*/forwardRef(({
  children,
  status,
  ...rest
}, ref) => /*#__PURE__*/React.createElement("div", {
  className: ax(["_kqwl1woi _nrflymdr _1yzo1ytf _1g1e12c5 _e03k1h6o _tjnb1spj _bd4y1woi _1t38ymdr _117t1ytf _wasv12c5 _158u1h6o _mgxm1spj _ddpz1bs3 _13wwidpf"])
}, /*#__PURE__*/React.createElement(Pressable, _extends({}, rest, {
  ref: ref,
  xcss: [buttonStyles, status === 'default' && brandStyles, status === 'warning' && warningStyles, status === 'danger' && dangerStyles]
}), /*#__PURE__*/React.createElement(Box, {
  xcss: iconStyles
}, status === 'default' && /*#__PURE__*/React.createElement(SparkleIcon, {
  label: "",
  primaryColor: "var(--ds-icon-discovery)"
}), status === 'warning' && /*#__PURE__*/React.createElement(WarningIcon, {
  label: "",
  color: "var(--ds-icon-warning)"
}), status === 'danger' && /*#__PURE__*/React.createElement(WarningIcon, {
  label: "",
  color: "var(--ds-icon-danger)"
})), children)));